import { gate } from 'hub-http/gates';
// v3 gates - https://product.hubteam.com/docs/gating/next-gen/usage.html#frontend-usage

export const FTS_STAGED_USERS = gate('FTS:StagedUsers');
export const M1_HUB_PAGES = gate('SSM:PricingPageV2:M1HubPages');